import { jsx as _jsx } from "react/jsx-runtime";
import { GradientStepper } from 'shared';
import { useSigningFlowStep } from '../hooks';
function SigningFlowStepper({ downPaymentRequired }) {
    const progress = useSigningFlowStep(downPaymentRequired);
    if (!progress)
        return null;
    return (_jsx(GradientStepper, { className: "flex-finalize-stepper", totalSteps: progress.totalSteps, currentStep: progress.currentStep, label: progress.label }));
}
export default SigningFlowStepper;
